module.exports = __webpack_public_path__ + "static/mobile-footer-smh-ac2f3c24b99e0fb2aeff68dade52b626.jpg";